/**
 * バナー関連 Class
 */
export default class Banner {
	constructor() {
		this.resizeEvent();
		this.sideBannerVisible();
	};

	/**
	 * リサイズイベント
	 */
	resizeEvent() {
		window.addEventListener('resize', this.sideBannerVisible);
	};

	/**
	 * 追従バナー表示切り替え
	 */
	sideBannerVisible() {
		let $windowW = window.outerWidth;
		if (1200 >= $windowW) {
			$('#js-side-banner').addClass('is-hidden');
		} else {
			$('#js-side-banner').removeClass('is-hidden');
		}
	};
}
